import { html, View } from 'rune-ts';
import klass from './BecomeFanButtonView.module.scss';
import { BecomeFanButtonEvent } from '../event/BecomeFanButtonEvent';
import { goLogin } from '../../../../../shared/util/goLogin';
import { myFanIconHeart } from '@services/MarppleShop/shared/components/atoms/Icon/foundation_icons.ts';

export interface BecomeFanButtonViewProps {
  is_liked: boolean;
  is_login: boolean;
  store_id: number;
}

export class BecomeFanButtonView extends View<BecomeFanButtonViewProps> {
  override template() {
    return html`
      <button class="${klass.become_fan_button}" type="button">
        ${myFanIconHeart({ color: this.data.is_liked ? 'blue' : 'gray20' })}
      </button>
    `;
  }

  private _getBecomeFanIsLiked() {
    return this.data.is_liked;
  }

  public toggleLiked() {
    /* TODO 팬 숫자 올리고 내리고 해야할듯~ */
    this.data.is_liked = !this.data.is_liked;
    this.redraw();
  }

  protected override onRender() {
    this.addEventListener('click', () => {
      if (this.data.is_login) {
        this.toggleLiked();
        this.dispatchEvent(BecomeFanButtonEvent, {
          bubbles: true,
          detail: {
            store_id: this.data.store_id,
            is_liked: this._getBecomeFanIsLiked(),
            view: this,
          },
        });
      } else {
        return goLogin();
      }
    });
  }
}
